var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSequelize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "-3.243 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.516 15.302L35.516 32.587L20.828 41.277L20.695 41.398L20.695 47.859L20.828 47.984L41.514 36.035L41.514 11.949L41.318 11.901L35.486 15.161L35.516 15.302",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.092 32.729L20.828 41.277L20.828 47.984L0 35.988L0 11.996L0.214 11.964L6.029 15.344L6.092 15.538L6.092 32.729",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.092 15.538L0 11.996L20.78 0L41.514 11.949L35.516 15.302L20.78 6.895L6.092 15.538",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.575 30.752L20.415 30.589L20.415 24.099L20.575 24.016L20.614 23.856L26.178 20.61L26.348 20.648L26.348 27.336L20.575 30.752",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.705 27.545L14.705 20.6L14.866 20.592L20.527 23.886L20.575 24.016L20.575 30.752L14.705 27.545",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.478 17.184L14.705 20.6L20.575 24.016L26.348 20.648L20.478 17.184",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.39 34.986L13.23 34.823L13.23 28.332L13.39 28.25L13.429 28.09L18.993 24.844L19.163 24.882L19.163 31.57L13.39 34.986",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52 31.779L7.52 24.834L7.681 24.826L13.342 28.121L13.39 28.25L13.39 34.986L7.52 31.779",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.294 21.418L7.52 24.834L13.39 28.25L19.163 24.882L13.294 21.418",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.273 35.147L28.113 34.984L28.113 28.493L28.273 28.411L28.312 28.251L33.876 25.005L34.047 25.043L34.047 31.73L28.273 35.147",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.403 31.939L22.403 24.995L22.564 24.987L28.225 28.281L28.273 28.411L28.273 35.147L22.403 31.939",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.177 21.579L22.403 24.995L28.273 28.411L34.047 25.043L28.177 21.579",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.088 39.381L20.928 39.218L20.928 32.727L21.088 32.645L21.127 32.484L26.691 29.239L26.862 29.277L26.862 35.964L21.088 39.381",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.218 36.173L15.218 29.229L15.379 29.221L21.04 32.515L21.088 32.645L21.088 39.381L15.218 36.173",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.992 25.812L15.218 29.229L21.088 32.645L26.862 29.277L20.992 25.812",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.575 21.546L20.415 21.384L20.415 14.893L20.575 14.811L20.614 14.65L26.178 11.405L26.348 11.443L26.348 18.13L20.575 21.546",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.705 18.339L14.705 11.394L14.866 11.387L20.527 14.681L20.575 14.811L20.575 21.546L14.705 18.339",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.478 7.978L14.705 11.394L20.575 14.811L26.348 11.443L20.478 7.978",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.39 25.78L13.23 25.618L13.23 19.127L13.39 19.044L13.429 18.884L18.993 15.638L19.163 15.677L19.163 22.364L13.39 25.78",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52 22.573L7.52 15.629L7.681 15.621L13.342 18.915L13.39 19.044L13.39 25.78L7.52 22.573",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.294 12.212L7.52 15.629L13.39 19.044L19.163 15.677L13.294 12.212",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.273 25.941L28.113 25.778L28.113 19.287L28.273 19.205L28.312 19.045L33.876 15.799L34.047 15.837L34.047 22.525L28.273 25.941",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.403 22.733L22.403 15.789L22.564 15.781L28.225 19.075L28.273 19.205L28.273 25.941L22.403 22.733",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.177 12.373L22.403 15.789L28.273 19.205L34.047 15.837L28.177 12.373",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.088 30.175L20.928 30.012L20.928 23.521L21.088 23.439L21.127 23.279L26.691 20.033L26.862 20.071L26.862 26.759L21.088 30.175",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.218 26.967L15.218 20.023L15.379 20.015L21.04 23.309L21.088 23.439L21.088 30.175L15.218 26.967",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.992 16.607L15.218 20.023L21.088 23.439L26.862 20.071L20.992 16.607",
    fill: "#03AFEF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequelize);
export default __webpack_public_path__ + "static/media/sequelize.df2a3fcf27ef5da613c649af3924eb15.svg";
export { ForwardRef as ReactComponent };